import { useState } from 'react';
import Hero from './components/Hero';
import FilterButtons from './components/FilterButtons';
import PortfolioGallery from './components/PortfolioGallery';

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('all');

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <FilterButtons 
            activeCategory={activeCategory} 
            onCategoryChange={setActiveCategory} 
          />
          <PortfolioGallery activeCategory={activeCategory} />
        </div>
      </section>
    </div>
  );
}
